import styled from 'styled-components'

const Wrapper = styled('div')`
  margin: 16px 0 24px;
`

export default Wrapper
